<template>
    <div v-if="!isLoading">
        <div id="viewport-measure" style="position: fixed; top: 0; height: 100vh; width: 100vw; pointer-events: none; opacity: 0;"></div>
        <div ref = "backgroundColor" class = "fixed w-screen h-screen bg-[#DED9CD] pointer-events-none">
        </div>
        <div class = "fixed w-screen h-screen right-0 top-0 bg-[#DED9CD] pointer-events-none hidden" ref = "bar">
            <div class = "bg-[#AA9E81] opacity-[0.3] rotate-30 h-[300%] w-[60%] md:w-[30%] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"></div>
            <div class = "absolute -bottom-[1px] left-0 w-full h-[2px] bg-black block md:hidden"></div>
        </div>
        <div ref = "resizeOverlay" class = "fixed top-0 left-0 w-screen h-[100dvh] opacity-0 pointer-events-none bg-black flex justify-center items-center" style="z-index: 1000001;">
            <img :src = "site.nav.logo.light" ref = "resizeOverlayLogo" class = "w-[200px] h-auto opacity-0" alt = "" />
        </div>
        <div ref = "mainContainer" :class = "[isHomePage() ? 'overflow-hidden w-full h-screen' : 'w-full min-h-screen bg-[#DED9CD] pt-[100px] flex flex-col justify-between']">
            <div v-if="isHomePage()" class = "w-full overflow-hidden">
                <main ref = "scrollContainer" class = "w-screen relative overflow-hidden">
                    <CrossfireIntro ref = "intro" :site="site" :timings="timings" :mainTimeline="tl" @unlockPage="unlockPage" @preMount="preMountBelowTheFold" @lottieReady="onIntroLottieLoaded" :isReady="isReadyToStart" :mountLazy="mountStage >= 1"/>
                    <CrossfireTrailer v-if="mountStage >= 2" ref = "trailer" :site="site" :timings="timings" :mainTimeline="tl" :unlocked = "unlocked" />
                    <CinematicNarrative v-if="mountStage >= 3" ref = "cinematic" :site="site" :timings="timings" :mainTimeline = "tl" :currentLanguage="currentLanguage" />
                    <Tactical v-if="mountStage >= 4" ref = "tactical" :site="site" :timings="timings" :mainTimeline = "tl" :currentLanguage="currentLanguage" />
                    <Combat v-if="mountStage >= 5" ref = "combat" :site="site" :timings="timings" :mainTimeline = "tl" :currentLanguage="currentLanguage" />
                    <Allies v-if="mountStage >= 6" ref = "allies" :site="site" :timings="timings" :mainTimeline = "tl" :currentLanguage="currentLanguage" />
                    <Environments v-if="mountStage >= 7" ref = "environments" :site="site" :timings="timings" :mainTimeline = "tl" @handleInternalLinkClick="(to) => handleInternalLinkClick(to)" :unlocked = "unlocked" :disableVideos="disableVideos" :disableDownloads="disableDownloads" :disableConceptArt="disableConceptArt" :currentLanguage="currentLanguage" />
                </main>
            </div>
            <FAQ v-if="isHomePage() && mountStage >= 8 && !disableFaq" ref = "faq" :site="site"/>
            <Footer v-if="isHomePage() && mountStage >= 9" ref = "footerComponent" :site="site" />

            <template v-if="!isHomePage()">
                <CrossfireGeneric :pageData="currentPageData" :isLoading="isLoadingPage" />
                <Footer ref = "footerComponent" :site="site" />
            </template>
            <div :class = "[
                'fixed w-full left-0 z-[150] px-[15px] lg:px-[2vw] font-[700] font-[alternate-gothic-compressed] text-[21px] tracking-[2.7px] transition-all duration-300 flex justify-between items-center gap-12',
                isHomePage() ? 'top-[15px] lg:top-[20px] opacity-0 text-white' : 'top-0 py-[15px] lg:py-[20px] opacity-100 bg-[#DED9CD] text-[#243036] [&_.dark]:opacity-100 [&_.light]:opacity-0'
            ]" ref = "header">
                <router-link v-if="site.nav && site.nav.wishlist && site.nav.wishlist.startsWith('/')" :to="site.nav.wishlist" @click="() => handleInternalLinkClick(site.nav.wishlist)" class="flex gap-4 items-center w-[25%] cursor-pointer hover:opacity-80 transition-opacity">
                    <div class = "relative h-full w-auto">
                        <img src = "@/assets/images/header/controller-icon-dark.svg" alt = "" class = "h-full w-auto light"/>
                        <img src = "@/assets/images/header/controller-icon.svg" alt = "" class = "absolute top-0 left-0 h-full w-auto opacity-0 dark"/>
                    </div>
                    <div class = "hidden lg:block whitespace-nowrap uppercase">{{ site.preOrderText }}</div>
                </router-link>
                <a v-else-if="site.nav && site.nav.wishlist" :href="site.nav.wishlist" target="_blank" class="flex gap-4 items-center w-[25%] cursor-pointer hover:opacity-80 transition-opacity">
                    <div class = "relative h-full w-auto">
                        <img src = "@/assets/images/header/controller-icon-dark.svg" alt = "" class = "h-full w-auto light"/>
                        <img src = "@/assets/images/header/controller-icon.svg" alt = "" class = "absolute top-0 left-0 h-full w-auto opacity-0 dark"/>
                    </div>
                    <div class = "hidden lg:block whitespace-nowrap uppercase">{{ site.preOrderText }}</div>
                </a>
                <div v-else class = "flex gap-4 items-center w-[25%]">
                    <div class = "relative h-full w-auto">
                        <img src = "@/assets/images/header/controller-icon-dark.svg" alt = "" class = "h-full w-auto light"/>
                        <img src = "@/assets/images/header/controller-icon.svg" alt = "" class = "absolute top-0 left-0 h-full w-auto opacity-0 dark"/>
                    </div>
                    <div class = "hidden lg:block whitespace-nowrap uppercase">{{ site.preOrderText }}</div>
                </div>
                <router-link to="/intro" @click="() => handleInternalLinkClick(`/intro`)"><div class = "relative h-full w-auto">
                    <img :src = "site.nav.logo.light" alt = "" class = "light min-w-[150px] max-w-[150px] h-auto" />
                    <img :src = "site.nav.logo.dark" alt = "" class = "absolute top-0 left-0 h-full w-auto opacity-0 dark" />
                </div></router-link>
                <div class = "flex gap-12 items-center w-[25%] justify-end h-full">
                    <div class = "h-full w-auto block lg:hidden relative cursor-pointer" ref = "mobileMenuBtn" @click="$refs.mobileMenu.openMenu()">
                        <img src = "@/assets/images/header/mobile/mobile-menu-button.svg" alt = "" class = "h-full w-auto block light"/>
                        <img src = "@/assets/images/header/mobile/mobile-menu-button-dark.svg" alt = "" class = "absolute top-0 left-0 h-full w-auto opacity-0 dark"/>
                    </div>
                    <div class = "gap-[2.8vw] items-center hidden lg:flex">
                        <router-link
                            v-for="item in site.nav.nav"
                            :key="item.link"
                            :to="item.link"
                            @click="() => handleInternalLinkClick(item.link)"
                        >
                            <div class="whitespace-nowrap uppercase group relative pb-[10px] -mb-[10px] hover:text-[#AB9779] hover:text-shadow-glow">
                                {{ item.title }}
                                <div class = "absolute bottom-0 left-0 w-full h-[1.5px] bg-[#AB9779] group-hover:opacity-100 opacity-0 transition-opacity bar"></div>
                            </div>
                        </router-link>
                    </div>
                    <div class = "h-full hidden lg:block relative min-w-[20px] cursor-default group" ref = "languagesBtn">
                        <img src = "@/assets/images/header/desktop/languages.svg" alt = "" class = "relative h-full w-auto block light" />
                        <img src = "@/assets/images/header/desktop/languages-dark.svg" alt = "" class = "absolute top-0 left-0 h-full w-auto opacity-0 dark" />
                        <div class = "cf-ring absolute opacity-0 pointer-events-none w-[50%] h-[50%] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full border-solid border-[1px] group-hover:opacity-100 group-hover:w-[150%] group-hover:h-[150%] transition-all duration-200 ease-in-out"></div>
                        <div ref = "languages" class = "opacity-0 translate-y-[30px] pointer-events-none absolute top-full -right-[15px] cursor-default pt-[20px] group-hover:opacity-100 group-hover:translate-y-0 group-hover:pointer-events-auto transition-all duration-200 ease-in-out">
                            <div class = "p-[20px] w-full relative">
                                <div class = "absolute w-full h-full top-0 left-0 pointer-events-none opacity-40">
                                    <div class = "bg-black absolute w-full h-full top-0 left-0"></div>
                                    <div class = "bg-black w-[9px] h-[9px] rotate-45 absolute -top-[4px] right-[20px]"></div>
                                </div>
                                <div class = "z-10 relative flex flex-col gap-2 text-white font-body min-w-[150px] text-[12px] font-[400]">
                                    <div v-for="(site, index) in site.sites" :key="index" ref = "language" language = "language" class = "relative pl-[20px] cursor-pointer hover:[&_img]:opacity-100" :class="`${currentLanguage == site.slug ? '[&_img]:opacity-100': ''}`" @click = "handleChangeLanguage(site)">
                                        <img src = "@/assets/images/menu/check.svg" class = "invert absolute top-1/2 left-0 -translate-y-1/2 opacity-0 pointer-events-none transition-opacity duration-300 w-[15px] h-auto" alt = "" />
                                        <span>{{ site.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isHomePage()" class = "fixed top-0 opacity-0 left-[15px] lg:left-[4vw] h-screen z-[110] flex flex-col justify-center" ref = "scrollbar">
                <div class = "max-h-[250px] lg:max-h-[250px] h-full py-8 flex flex-col items-center gap-2">
                    <div class = "text-white uppercase relative">
                        <div v-if="scrollIndicatorIsCjk" class = "cf-scroll-vertical tracking-[0.5px] text-[12px] lg:text-[15px]">{{ site.scrollIndicatorText }}</div>
                        <div v-else class = "-rotate-90 origin-left absolute -mt-4 tracking-[0.5px] text-[12px] lg:text-[15px]">{{ site.scrollIndicatorText || 'Scroll' }}</div>
                    </div>
                    <div class = "w-[6px] h-[1.3px] lg:w-[16px] bg-white hidden lg:block"></div>
                    <div class = "w-[1.5px] lg:w-[2px] relative bg-white/20 h-full overflow-hidden">
                        <div class = "w-full bg-white absolute top-0 left-0" ref = "scrollbarInner"></div> 
                    </div>
                    
                </div>
            </div>
            <div v-if="isHomePage()" class = "fixed w-full bottom-[20px] left-0 justify-end items-center gap-12 z-10 px-[15px] lg:px-[20px] hidden lg:flex" ref = "footer">
                <div class = "relative">
                    <img :src = "site.nav.footerLogo.light" alt = "" class = "h-full w-auto block light min-h-[50px]" />
                    <img :src = "site.nav.footerLogo.dark" alt = "" class = "absolute top-0 left-0 h-full w-auto opacity-0 dark" />
                </div>
            </div>
        </div>
        <Popup
        ref="globalPopup"
        :type="popupState.type"
        :video="popupState.video"
        :image="popupState.image"
        :maxWidth="popupState.maxWidth"
        :items="activePopupItems"
        :index="popupState.index !== null ? Number(popupState.index) : null"
        :downloadText="site.downloadButtonText"
        :hideDownload="popupState.slider === 'conceptArt' || popupState.slider === 'screenshots'"
        @close="handleGlobalPopupClose"
        @change-item="handlePopupChangeItem"
        />
        <MobileMenu :site="site" ref = "mobileMenu" @handleInternalLinkClick="(to) => handleInternalLink(to, true)" @lockAutoScroll="setAutoScrolling(true)" @changeLanguage="(site) => handleChangeLanguage(site)" :currentLanguage="currentLanguage" />
        <AgeGate v-if="isSettingsLoaded && !disableAgeGate" @verified="onAgeVerified" />
    </div>
    <!-- Global Black Background Loader -->
    <transition name="fade">
        <div v-if="showGlobalLoader" class="fixed inset-0 bg-[#000] z-[99999] flex justify-center items-center pointer-events-auto">
            <h2 class="text-white text-center text-[40px] md:text-5xl font-['alternate-gothic-compressed'] tracking-[2.7px] uppercase animate-pulse duration-50">
                {{ site.loadingText || 'Loading...' }}
            </h2>
        </div>
    </transition>
    <div ref = "mobileBlocker" class = "fixed z-[100000] flex justify-center items-center w-screen h-screen top-0 left-0 overflow-hidden" style="background-color: #DED9CD;">
        <!-- Background ellipses — centered at natural size, matching the comp rings -->
        <img src="@/assets/images/mobile-blocker/rings.svg" alt="" class="absolute pointer-events-none" style="top: 50%; left: 50%; transform: translate(-50%, -50%); width: 90vw; max-width: 582px; height: auto; opacity: 0.5;" />
        <!-- Content -->
        <div class="relative flex flex-col items-center gap-[20px] z-10">
            <p class="text-black font-['alternate-gothic-compressed'] text-[22px] tracking-[0.25em] uppercase">Rotate Your Device</p>
            <!-- Phone icon with arrow overlaid -->
            <div class="relative">
                <img src="@/assets/images/mobile-blocker/phone.svg" alt="Rotate device" class="w-[200px] h-auto" />
                <img src="@/assets/images/mobile-blocker/arrow.svg" alt="" class="absolute pointer-events-none" style="width: 52px; height: auto; top: 8%; left: 15%;" />
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';

import CrossfireIntro from '@/components/pages/Intro.vue';
import AgeGate from './components/pieces/AgeGate.vue';

const MobileMenu = defineAsyncComponent(() => import('./components/pieces/MobileMenu.vue'));
const CrossfireTrailer = defineAsyncComponent(() => import('@/components/pages/Trailer.vue'));
const CinematicNarrative = defineAsyncComponent(() => import('@/components/pages/CinematicNarrative.vue'));
const Tactical = defineAsyncComponent(() => import('@/components/pages/Tactical.vue'));
const Combat = defineAsyncComponent(() => import('@/components/pages/Combat.vue'));
const Allies = defineAsyncComponent(() => import('@/components/pages/Allies.vue'));
const Environments = defineAsyncComponent(() => import('@/components/pages/Environments.vue'));
const FAQ = defineAsyncComponent(() => import('@/components/pages/FAQ.vue'));
const Footer = defineAsyncComponent(() => import('@/components/pages/Footer.vue'));
const Popup = defineAsyncComponent(() => import('./components/pieces/Popup.vue'));
const CrossfireGeneric = defineAsyncComponent(() => import('@/components/pages/Generic.vue'));

import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
import site from '@/json/site.json';
import axios from 'axios'

import { getScrollScale } from './components/helpers/scrollConfig';
import { hasCJK, convertSpacesInObject } from './components/helpers/textFit';
import { isDesktop } from './components/helpers/mobile';

export default {
    name: 'App',
    components: {
        CrossfireIntro,
        CrossfireTrailer,
        Popup,
        CinematicNarrative,
        Tactical,
        Combat,
        Allies,
        Environments,
        FAQ,
        Footer,
        MobileMenu,
        AgeGate,
        CrossfireGeneric
    },
    data() {
        return {
            exclude: [
                "intro",
                'header',
                'transition',
                'media'
            ],
            tl: null,
            scrollTrigger: null,
            finalTL: null,
            finalScrollTrigger: null,
            initialWindowWidth: 0,
            router: null,
            route: null,
            slugSections: [],
            popupState: {
                type: null,
                video: null,
                image: null,
                maxWidth: 1200,
                id: null,
                index: null,
                slider: null,
            },
            unlocked: false,
            lastSlug: { value: '' },
            showLight: 'block',
            showDark: 'none',
            resizeTimeout: null,
            resizedWhileTrailerOpen: false,
            horizontalStart: 0,
            inited: false,
            site: site,
            currentLanguage: '',
            debouncedReload: null,
            prevWidth: window.innerWidth,
            blockerShown: false,
            blockerActive: false,
            offsets: {
                unlikelyAllies: -3.0,
                trailer: -0.5,
                faq: {
                    desktop: 1.65,
                    mobile: 1.2
                }
            },
            sitePrefix: null,
            siteHandle: 'default',
            isLoading: true,
            isGlobalDataLoaded: false,
            ageGateVerified: false,
            isAutoScrolling: false,
            scrollReleaseTimer: null,
            scrollReleaseAnimationFrame: null,
            isReadyToStart: false,
            hasStartedIntro: false,
            timelineBuildInitiated: false,
            mountStage: 0,
            introLottieLoaded: false,
            currentPageData: null,
            isLoadingPage: false,
            // SEO/share meta: globalMeta = Settings global (per-site, with
            // default-site fallback already resolved server-side); pageMeta =
            // current page's own fields, which override the global.
            globalMeta: {},
            pageMeta: {},
            disableAgeGate: false,
            disableFaq: false,
            disableVideos: false,
            disableDownloads: false,
            disableConceptArt: false,
            useAlternativeFont: false,
            useKoreanFont: false,
            isLocalized: false,
            languageClass: '',
            isSettingsLoaded: false
        }
    },
    created() {
        const isHome = this.isHomePageRoute(window.location.pathname);
        if (!isHome) {
            this.isLoadingPage = true;
        }
    },
    mounted() {
        window.__crossfireAutoScrollLock = false;
        this.initialWindowWidth = window.innerWidth;
        window.addEventListener('scroll', this.scrollbarTrack, { passive: true });
        window.addEventListener('resize', this.resizeHandler);
        window.addEventListener('orientationchange', this.resizeHandler);
        
        // Manual interaction safety unlock to prevent auto-scrolling flags from getting stuck
        window.addEventListener('wheel', this.manualUnlock, { passive: true });
        window.addEventListener('touchmove', this.manualUnlock, { passive: true });
        window.addEventListener('pointerdown', this.manualUnlock, { passive: true });
        // Detect site prefix synchronously using static local JSON to prevent any Flash of Unstyled Content
        if (this.site && this.site.sites) {
            const pathFirstSegment = window.location.pathname.split('/')[1];
            // Use local JSON fallback to set language prefixes instantly
            const matchedSite = this.site.sites.find((s) => s.slug && s.slug.toLowerCase() === pathFirstSegment.toLowerCase());
            if (matchedSite) {
                console.log('Detected early site slug:', matchedSite.slug);
                this.sitePrefix = matchedSite.slug.toLowerCase();
                this.currentLanguage = matchedSite.slug;
            }
        }

        // Initialize lastSlug to prevent redundant route replacements triggering mobile menu closing
        let initialSlug = this.getSlugFromLocation(window.location.pathname);
        if (this.sitePrefix && initialSlug) {
            initialSlug = initialSlug.replace(new RegExp('^' + this.sitePrefix + '(/|$)', 'i'), '');
        }
        this.lastSlug.value = initialSlug || '/';

        this.debouncedReload = this.debounce(function() {
            window.location.reload();
        });

        // Check for verified cookie early on load (using both cookie and localStorage fallback)
        let isAgeVerified = false;
        try {
            const match = document.cookie.match(new RegExp('(^| )age_verified=([^;]+)'));
            if (match && match[2] === 'true') {
                isAgeVerified = true;
            }
        } catch (e) {
            console.error("Early cookie read error:", e);
        }
        try {
            if (!isAgeVerified && window.localStorage && window.localStorage.getItem('age_verified') === 'true') {
                isAgeVerified = true;
            }
        } catch (e) {
            console.error("Early localStorage read error:", e);
        }

        if (isAgeVerified) {
            this.ageGateVerified = true;
        }

        // Always kick off the global data fetch, even when the mobile-rotate
        // blocker is showing. Otherwise a reload while the phone is in
        // landscape (e.g. after rotating with the trailer open) bails out of
        // mounted() before fetchGlobalData() runs, so isLoading never clears
        // and the app is stuck on the loading screen once rotated back.
        this.fetchGlobalData();

        if (this.showMobileBlocker()) {
            return;
        }

        // Run layout tracker immediately
        this.scrollbarTrack();

        // Set pin protection on images early
        this.$nextTick(() => {
            for (const img of document.querySelectorAll('img')) {
                img.setAttribute('data-pin-nopin', 'true');
            }
            // Instantly attempt to start the intro (non-blocking!)
            this.checkStartIntro();
        });
    },
    unmounted() {
        window.removeEventListener('scroll', this.scrollbarTrack);
        window.removeEventListener('resize', this.resizeHandler);
        window.removeEventListener('orientationchange', this.resizeHandler);
        window.removeEventListener('wheel', this.manualUnlock);
        window.removeEventListener('touchmove', this.manualUnlock);
        window.removeEventListener('pointerdown', this.manualUnlock);
        window.removeEventListener('keydown', this.manualUnlockKeydown);
    },
    methods: {
        manualUnlock() {
            if (this.isAutoScrolling) {
                console.log('[Slug Debug] Manual scroll safety unlock triggered.');
                this.setAutoScrolling(false);
                if (this.scrollReleaseTimer) {
                    this.scrollReleaseTimer.kill();
                    this.scrollReleaseTimer = null;
                }
                if (this.scrollReleaseAnimationFrame) {
                    cancelAnimationFrame(this.scrollReleaseAnimationFrame);
                    this.scrollReleaseAnimationFrame = null;
                }
            }
        },
        manualUnlockKeydown(e) {
            const keys = ['ArrowUp', 'ArrowDown', 'Space', 'PageUp', 'PageDown', 'Home', 'End'];
            if (keys.includes(e.key)) {
                this.manualUnlock();
            }
        },
        setAutoScrolling(val) {
            this.isAutoScrolling = val;
            window.__crossfireAutoScrollLock = val;
        },
        openPopup({ type, video, image, maxWidth = 1200, id, index = null, slider = null }) {
            this.popupState = { type, video, image, maxWidth, id, index, slider };
            if (id === 'watch') {
                this.resizedWhileTrailerOpen = false;
            }

            // Add the ?popup=id query param
            this.$router.replace({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    popup: id,
                    ...(index != null ? { index } : {}),
                    ...(slider != null ? { slider } : {})
                },
            });

            this.$nextTick(() => {
                this.$refs.globalPopup.show();
            });
        },
        handleGlobalPopupClose() {
            const isTrailer = this.popupState?.id === 'watch' || this.$route?.query?.popup === 'watch';
            // Did the device rotate while the trailer was open? If so the pinned
            // timeline is stale and the page must rebuild.
            const rotatedWhileOpen = isTrailer && this.resizedWhileTrailerOpen;
            this.resizedWhileTrailerOpen = false;
            // Are we currently on a phone held in landscape (i.e. the rotate blocker
            // would show)? Mirror the showMobileBlocker() check.
            const isLandscapePhone = window.innerWidth > window.innerHeight
                && (window.innerWidth < 768 || window.innerHeight < 600);

            this.popupState = {
                type: null,
                video: null,
                image: null,
                maxWidth: 1200,
                id: null,
                index: null,
                slider: null,
            };
            // Close popup handler (cleanly strip queries while preserving current path)
            const query = { ...this.$route.query };
            delete query.popup;
            delete query.index;
            delete query.slider;

            // If it rotated while open AND we're back in a usable portrait orientation,
            // rebuild now by reloading. Reloading only in portrait means we never land
            // on the rotate blocker. If we're still in landscape, skip the reload here —
            // showMobileBlocker() shows the prompt and the portrait-return resize handler
            // rebuilds once the user rotates back.
            if (rotatedWhileOpen && !isLandscapePhone) {
                this.$router.replace({
                    path: this.$route.path,
                    query: query
                }).finally(() => {
                    window.location.reload();
                });
                return;
            }

            this.$router.replace({
                path: this.$route.path,
                query: query
            }).then(() => {
                this.showMobileBlocker();
            }).catch(() => {
                this.showMobileBlocker();
            });

            this.$nextTick(() => {
                this.showMobileBlocker();
            });
        },
        toSlug(camel) {
            // intro            → intro
            // developedBy      → developed-by
            return camel.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        },
        getOffset(key) {
            const offsets = this.offsets;
            if(!offsets) return 0;

            const val = offsets[key];
            if (val && typeof val === 'object') {
                return window.innerWidth >= 768 ? (val.desktop ?? 0) : (val.mobile ?? 0);
            }
            return val ?? 0;
        },
        makeSlugSections() {
            const timingsObj = this.timings;
            const sections = [];
            let t = 0;

            for (const [key, len] of Object.entries(timingsObj)) {
                sections.push({ myKey: key, slug: this.toSlug(key), time: +t.toFixed(3), length: len, offset: this.getOffset(key) });
                t += len;
            }

            this.slugSections = sections;
        },
        addSectionLabels(tl, slugSections, extras = {}) {
            let t = 0;
            for (const section of slugSections) {
                tl.addLabel(`${section.myKey}Point`, t);
                console.log(`${section.myKey}Point`, t);
                t += section.length;
            }
            // any extra labels that don't map 1‑to‑1 with a section
            Object.entries(extras).forEach(([name, time]) => tl.addLabel(name, time));
        },
        getSectionStart(tl, section, noOffset = false) {
            if (!tl) return null;
            const st = tl.scrollTrigger;
            if (!st) return null;

            const scrollRange = st.end - st.start;
            const duration = this.tl.duration();

            const time = section.time;
            const offset = noOffset ? 0 : section.offset;

            const sectionStart = ((time + offset) / duration ) * scrollRange;

            return sectionStart + 1;
        },
        initAnimation() {
            if (this.tl) return;

            this.tl = gsap.timeline();
            this.finalTL = gsap.timeline();
            this._cachedLabelEntries = null; // ✅ Perf: cache label computation

            let currentSlug = null;

            this.tl.eventCallback('onUpdate', () => {
                if (!this.isReadyToStart || !this.tl) return;
                const isLocked = this.isAutoScrolling || window.__crossfireAutoScrollLock || (this.$refs.mobileMenu && this.$refs.mobileMenu.isOpen);
                if (isLocked) {
                    console.log('[Slug Debug] onUpdate locked:', {
                        isAutoScrolling: this.isAutoScrolling,
                        autoScrollLock: window.__crossfireAutoScrollLock
                    });
                    return;
                }
                if (this.popupState && this.popupState.id) return;
                const time = this.tl.time();

                const st = this.tl.scrollTrigger;
                if (!st) {
                    console.log('[Slug Debug] no scrollTrigger on timeline');
                    return;
                }

                const scrollRange = st.end - st.start;
                const duration = this.tl.duration();
                const currentScroll = (time / duration) * scrollRange;

                let newSlug = null;
                let isHiddenSlug = false;

                // ✅ Perf: compute label entries once and cache (labels never change after createTimeline)
                if (!this._cachedLabelEntries) {
                    this._cachedLabelEntries = Object.entries(this.tl.labels)
                        .filter(([label]) => label.endsWith('Point'))
                        .map(([label, t]) => {
                            const base = label.slice(0, -5); // remove "Point"
                            const slug = base.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase(); // camelCase to kebab-case
                            return { slug, time: t };
                        })
                        .sort((a, b) => a.time - b.time);
                }
                const labelEntries = this._cachedLabelEntries;

                for (const { slug } of labelEntries) {
                    const section = this.getSectionFromSlug(slug);
                    if (!section) continue;
                    
                    const scrollY = this.getSectionStart(this.tl, section, false);

                    if (currentScroll >= scrollY) {
                        if(!this.exclude.includes(slug)) {
                            newSlug = slug;
                        } else {
                            if(slug == 'intro') {
                                isHiddenSlug = true;
                            } else if (slug === 'media') {
                                const mediaComp = this.$refs.environments?.$refs?.media;
                                if (mediaComp) {
                                    const slugMap = ['videos', 'screenshots', 'concept-art', 'downloads'];
                                    const tabIndex = mediaComp.activeTab ?? 0;
                                    newSlug = `media/${slugMap[tabIndex]}`;
                                }
                            }
                        }
                    } else {
                        break;
                    }
                }

                console.log('[Slug Debug] computed slug:', {
                    currentScroll,
                    newSlug,
                    lastSlugValue: this.lastSlug.value,
                    isHiddenSlug
                });

                if(currentSlug == newSlug && !isHiddenSlug) return;
                currentSlug = newSlug;

                if(!this.$route.query.popup) {
                    const normalize = (s) => (s || '');
                    if (newSlug && normalize(newSlug) !== normalize(this.lastSlug.value) && !this.$route.params.popupSlug) {
                        console.log('[Slug Debug] Updating route path to:', newSlug);
                        this.lastSlug.value = newSlug;
                        this._scrollSyncNav = true; // mark as scroll-driven so it doesn't close the mobile menu
                        this.$router.replace({ path: `/${(this.sitePrefix ? this.sitePrefix + '/' : '') + newSlug}`,  query: { ...this.$route.query, } });
                    } else if(!newSlug && this.lastSlug.value && this.lastSlug.value !== '/') {
                        console.log('[Slug Debug] Clearing route path back to root');
                        this.lastSlug.value = '/';
                        this._scrollSyncNav = true; // mark as scroll-driven so it doesn't close the mobile menu
                        this.$router.replace({ path: `/${(this.sitePrefix ? this.sitePrefix + '/' : '')}`,  query: { ...this.$route.query, } });
                    }
                }
            });
        },
        onAgeVerified() {
            this.ageGateVerified = true;
            this.checkStartIntro();
        },
        onIntroLottieLoaded() {
            this.introLottieLoaded = true;
        },
        checkStartIntro() {
            console.log('[Intro Diagnostic] checkStartIntro evaluated:', {
                ageGateVerified: this.ageGateVerified,
                introExists: !!this.$refs.intro,
                hasStartedIntro: this.hasStartedIntro,
                isGlobalDataLoaded: this.isGlobalDataLoaded,
                isReadyToStart: this.isReadyToStart
            });
            if (this.ageGateVerified && this.$refs.intro && !this.hasStartedIntro && this.isGlobalDataLoaded && this.isReadyToStart) {
                console.log('[Intro Diagnostic] Launching intro playback sequence.');
                this.hasStartedIntro = true;
                this.$refs.intro.start();
                
                for (const img of document.querySelectorAll('img')) {
                    img.setAttribute('data-pin-nopin', 'true');
                }
            }
        },
        triggerTimelineBuild() {
            if (this.timelineBuildInitiated) return;
            this.timelineBuildInitiated = true;

            let logoWaitAttempts = 0;
            const checkAndBuild = () => {
                // If timeline build has been cancelled or another route transition reset it, abort this orphaned loop immediately
                if (!this.timelineBuildInitiated) {
                    console.log('[triggerTimelineBuild] Aborting orphaned timeline builder poll loop.');
                    return;
                }
                logoWaitAttempts++;
                // Verify all lazy components AND the deferred logo elements are fully mounted 
                if (
                    this.$refs.intro && 
                    this.$refs.intro.$refs.circles && 
                    this.$refs.trailer && 
                    this.$refs.intro.$refs.circles.$refs.developedBy && 
                    this.$refs.cinematic && 
                    this.$refs.tactical && 
                    this.$refs.combat && 
                    this.$refs.allies && 
                    this.$refs.environments && 
                    this.$refs.environments.$refs.finalTransition && 
                    this.$refs.environments.$refs.media &&
                    (this.disableFaq || this.$refs.faq) &&
                    this.$refs.footerComponent &&
                    (this.$refs.intro.$refs.logo || logoWaitAttempts >= 30) // Race-condition guard: wait max 3s for logo JSON to render component
                ) {
                    // Fetch timeline builder, utilizing pre-warmed cache promise if available
                    const promise = this._timelinePromise || import('./components/helpers/timeline');
                    promise.then(({ createTimeline }) => {
                        // Double check timeline presence before building to prevent asynchronous crash
                        if (!this.tl) {
                            console.warn('[triggerTimelineBuild] this.tl is null, skipping createTimeline.');
                            return;
                        }
                        try {
                            createTimeline(this);
                        } catch (e) {
                            console.error('[triggerTimelineBuild] Error building timeline:', e);
                        }
                        setTimeout(() => {
                            this._cachedLabelEntries = null; // Clear cached empty labels to compute properly on first tick
                            this.isReadyToStart = true;
                            if (this.tl && this.$refs.bar) {
                                this.tl.set(this.$refs.bar, { display: 'block' }, 'environmentsPoint');
                            }
                            this.checkStartIntro();
                        }, 50);
                    });
                } else {
                    // In case subcomponents are still resolving async chunks, retry in 100ms
                    setTimeout(checkAndBuild, 100);
                }
            };

            checkAndBuild();
        },
        warmupAssets() {
            // 🚀 SAFARI HANDSHAKE RUNWAY: Introduce a 600ms grace period before beginning 
            // ANY heavy dynamic module parsing. This gives the browser an entirely unblocked 
            // main thread to instantly hide the video and establish a smooth rendering loop 
            // for the Lottie intro animation before back-grounding the evaluations.
            setTimeout(() => {
                // 1. Pre-warm the massive timeline.js chunk
                this._timelinePromise = import('./components/helpers/timeline');

                // 2. Stagger async component pre-warm requests across the logo animation window.
                // This warms up browser memory/V8 caches with ZERO foreground frame stutters.
                const loaders = [
                    () => import('@/components/pages/Circles.vue'), // 🚀 CRITICAL: First lazy element rendered inside Intro!
                    () => import('@/components/pages/Trailer.vue'),
                    () => import('@/components/pages/CinematicNarrative.vue'),
                    () => import('@/components/pages/Tactical.vue'),
                    () => import('@/components/pages/Combat.vue'),
                    () => import('@/components/pages/Allies.vue'),
                    () => import('@/components/pages/Environments.vue'),
                    () => import('@/components/pages/FAQ.vue'),
                    () => import('@/components/pages/Footer.vue')
                ];

                loaders.forEach((fn, idx) => {
                    setTimeout(() => {
                        fn().catch(() => {}); // Gracefully bypass or let standard resolver handle runtime failures
                    }, idx * 400); // Staggering fires all 9 loaders across 3.6s
                });
            }, 600);
        },
        staggeredMount() {
            if (this.mountStage > 0) return; // Safe double-trigger guard

            let stage = 0;
            const totalStages = 9; // Total steps (Circles + 8 core components)

            const nextStage = () => {
                // Defensive guard: if an external hook already escalated/forced full mount, abort loop
                if (this.mountStage >= totalStages) return;

                stage++;
                this.mountStage = stage;

                if (stage < totalStages) {
                    // 🐌 Micro-task DOM Construction: staggering by 250ms flattens CPU spikes to <10ms.
                    // This keeps the main-thread free to composite video frames at a fluid 60fps on slow CPUs!
                    setTimeout(nextStage, 250);
                } else {
                    // All layers injected! GSAP timeline build is deferred to unlockPage to prevent CPU starvation and video frame stalls at playback end.
                }
            };

            nextStage();
        },
        preMountBelowTheFold() {
            // ✨ Fallback / Immediate escalation logic: enforces full DOM presence
            if (this.mountStage < 9) {
                this.mountStage = 9;
            }
        },
        unlockPage() {
            if (this.mountStage < 9) {
                this.mountStage = 9;
            }

            if (!this.isReadyToStart) {
                // 🚀 DEFER TIMELINE BUILD: Trigger heavy parsing & preloads only AT THE END of the intro sequence.
                // This guarantees zero background CPU load during foreground cinematic videos!
                this.$nextTick(() => {
                    this.triggerTimelineBuild();
                });

                const waitInterval = setInterval(() => {
                    if (this.isReadyToStart) {
                        clearInterval(waitInterval);
                        this.unlockPage();
                    }
                }, 100);
                return;
            }

            this.$refs.mainContainer.classList.remove('h-screen');
            this.$refs.mainContainer.classList.remove('overflow-hidden');

            if (this.$refs.faq) {
                this.$refs.faq.initAnimation();
            }
            this.$refs.footerComponent.initAnimation();

            this.setAutoScrolling(true);

            if (this.scrollTrigger) {
                this.scrollTrigger.enable();
                this.scrollTrigger.refresh();
            }

            this.$nextTick(() => {

                if (this.finalScrollTrigger) {
                    this.finalScrollTrigger.enable();
                    this.finalScrollTrigger.refresh();
                }

                this.handleInternalLink(null, true);

            })
        },
        getSlugFromLocation(path = null) {
            if (!path) path = this.$route?.path ?? window.location.pathname; // e.g., "/test/test2/"

            return path.replace(/^\/|\/$/g, '');
        },
        getSectionFromSlug(slug) {
            if (slug === 'faq' && this.disableFaq) {
                return null;
            }
            const labels = this.tl?.labels || {};

            if (slug && slug.startsWith('media/')) {
                slug = 'media';
            }

            const camelSlug = slug
                .split('-')
                .map((part, index) => index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1))
                .join('');

            for (const [label, time] of Object.entries(labels)) {
                const normalizedLabel = label.endsWith('Point') ? label.slice(0, -5) : label;

                if (normalizedLabel === camelSlug) {
                    const offset = this.getOffset(camelSlug);
                    return { slug, time, offset, label };
                }
            }

            return null;
        },
        scrollbarTrack() {
            // Calculate scroll progress (0 to 1)
            const scrollableHeight = document.body.offsetHeight - window.innerHeight;
            const scrollProgress = Math.min(window.scrollY / scrollableHeight, 1); // Clamp at 1

            // Map progress to height (10px to 100%)
            const minHeight = 0; // Starting height in pixels
            const maxHeight = 100; // Ending height in percentage

            // If not scrolled at all, use 10px, otherwise interpolate
            const heightValue = (scrollProgress === 0) 
                ? `${minHeight}px` 
                : `${minHeight + (maxHeight - minHeight) * scrollProgress}%`;

            if (this.$refs.scrollbarInner) {
                this.$refs.scrollbarInner.style.height = heightValue;
            }

            // ✅ Viewport intersection triggers for vertical sections (Media, FAQ)
            const isLocked = this.isAutoScrolling || window.__crossfireAutoScrollLock || (this.$refs.mobileMenu && this.$refs.mobileMenu.isOpen);
            if (!isLocked && !this.$route.query.popup) {
                // Coordinate check: Only allow vertical viewport overrides if we have scrolled past the horizontal timeline end
                const canOverride = !this.tl || !this.tl.scrollTrigger || window.scrollY >= (this.tl.scrollTrigger.end - 50);
                if (canOverride) {
                    const faqEl = !this.disableFaq && this.$refs.faq?.$el;
                    const mediaComp = this.$refs.environments?.$refs?.media;
                    const mediaEl = mediaComp?.$refs?.scrollContainer;

                    let verticalSlug = null;

                    if (faqEl && faqEl.getBoundingClientRect().top < window.innerHeight * 0.7) {
                        verticalSlug = 'faq';
                    } else if (mediaEl && mediaEl.getBoundingClientRect().top < window.innerHeight * 0.7) {
                        const slugMap = ['videos', 'screenshots', 'concept-art', 'downloads'];
                        const tabIndex = mediaComp.activeTab ?? 0;
                        verticalSlug = `media/${slugMap[tabIndex]}`;
                    }

                    if (verticalSlug) {
                        const normalize = (s) => (s || '');
                        if (normalize(verticalSlug) !== normalize(this.lastSlug.value) && !this.$route.params.popupSlug) {
                            this.lastSlug.value = verticalSlug;
                            this._scrollSyncNav = true; // mark as scroll-driven so it doesn't close the mobile menu
                            this.$router.replace({
                                path: `/${(this.sitePrefix ? this.sitePrefix + '/' : '') + verticalSlug}`,
                                query: { ...this.$route.query }
                            });
                        }
                    }
                }
            }
        },
        getRouteFromSlug(slug) {
            if (!slug || typeof slug !== 'string') return null;
            return `/${slug}`;
        },
        sumObjectValues(obj) {
            return Object.values(obj).reduce((sum, value) => {
                if (typeof value === 'number') {
                return sum + value;
                }
                return sum;
            }, 0);
        },
        handleInternalLinkClick(to) {
            console.log('to', to)
            this.handleInternalLink(to);
        },
        handleInternalLink(path = null, unlocked = false) {
            if (this.scrollReleaseTimer) {
                this.scrollReleaseTimer.kill();
                this.scrollReleaseTimer = null;
            }
            if (this.scrollReleaseAnimationFrame) {
                cancelAnimationFrame(this.scrollReleaseAnimationFrame);
                this.scrollReleaseAnimationFrame = null;
            }
            this.setAutoScrolling(true);
            this.$nextTick(() => {

                let section;

                let slug = this.getSlugFromLocation(path);
                if (!slug) {
                    this.setAutoScrolling(false);
                    return;
                }
                
                // strip the language from the start of the slug if necessary
                if (this.sitePrefix) {
                    slug = slug.replace(new RegExp('^' + this.sitePrefix + '(/|$)', 'i'), '');
                }
            
                // set the router here to allow the prefix
                //this.router.replace({ path: `/${(this.sitePrefix ? this.sitePrefix + '/' : '') + slug}`,  query: { ...this.$route.query, } });

                section = this.getSectionFromSlug(slug);
                if (!section) {
                    this.setAutoScrolling(false);
                    return;
                }

                this.lastSlug.value = section.slug; // prevent onUpdate flicker

                if (!this.tl || !this.tl.scrollTrigger) {
                    console.warn('[handleInternalLink] Aborted scroll animation because timeline or scrollTrigger is null.');
                    this.setAutoScrolling(false);
                    return;
                }

                console.log('label', section.label)
                const offset = section.offset * getScrollScale();
                const scroll = this.tl.scrollTrigger.labelToScroll(section.label) + offset + 10;
                console.log('scroll', scroll)

                // Wait for layout → ScrollTrigger → DOM to stabilize
                requestAnimationFrame(() => {
                    const distance = Math.abs(window.scrollY - scroll);
                    if (distance < 30) {
                        // Already at the target (e.g. clicking "Watch Trailer" a
                        // second time). Just settle — do NOT refresh ScrollTrigger
                        // here: refreshing re-seeks the pinned timeline at the
                        // parked position, which resets transient reveals like the
                        // trailer play-button Lottie back to frame 0 (blank).
                        window.scrollTo(0, scroll);
                        this.setAutoScrolling(false);
                        if (unlocked) {
                            this.unlocked = true;
                        }
                        return;
                    }

                    if(unlocked) {

                        console.log('UNLOCKED');

                        // give it a second for the scrollTrigger to rebuild

                        gsap.to(window, {
                            scrollTo: { y: scroll, autoKill: false },
                            ease: 'power2.out',
                            duration: 1,      // <= 0 makes it an immediate set
                            overwrite: 'auto', // prevents conflicts with any running tweens
                            onComplete: () => {
                                console.log('[Slug Debug] scrollTo unlocked onComplete, settling...');
                                setTimeout(() => {
                                    console.log('[Slug Debug] unlocked settle complete, unlocking auto-scroll.');
                                    this.setAutoScrolling(false);
                                }, 150);
                            }
                        });

                    } else {

                        gsap.to(window, {
                            // autoKill lets a desktop user interrupt the scroll by
                            // scrolling manually. On mobile it's unreliable —
                            // scrolling up reveals the browser chrome (address bar),
                            // firing scroll/resize events that autoKill misreads as a
                            // manual scroll and kills the tween, leaving it stuck
                            // (e.g. the logo never reaching the top). Disable it there.
                            scrollTo: { y: scroll, autoKill: isDesktop() },
                            ease: 'power2.out',
                            duration: 1,      // <= 0 makes it an immediate set
                            overwrite: 'auto', // prevents conflicts with any running tweens
                            onComplete: () => {
                                console.log('[Slug Debug] scrollTo onComplete, settling...');
                                setTimeout(() => {
                                    console.log('[Slug Debug] settle complete, unlocking auto-scroll.');
                                    this.setAutoScrolling(false);
                                }, 150);
                            },
                            onAutoKill: () => {
                                if (this.scrollReleaseTimer) {
                                    this.scrollReleaseTimer.kill();
                                    this.scrollReleaseTimer = null;
                                }
                                if (this.scrollReleaseAnimationFrame) {
                                    cancelAnimationFrame(this.scrollReleaseAnimationFrame);
                                    this.scrollReleaseAnimationFrame = null;
                                }
                                this.setAutoScrolling(false);
                            }
                        });

                    }

                    requestAnimationFrame(() => {
                        this.scrollTrigger.refresh();
                    });

                    if(unlocked) {
                        this.unlocked = true;
                    }
                });
            });
        },
        showLanguages() {
            gsap.to(this.$refs.languagesBtn.querySelector('.cf-ring'), {
                opacity: 1,
                width: '150%',
                height: '150%',
                duration: 0.2,
                ease: 'power2.in'
            })
            gsap.to(this.$refs.languages, {
                opacity: 1,
                y: 0,
                pointerEvents: 'auto',
                duration: 0.2,
                ease: 'power2.in'
            }, '-=0.2')
        },
        hideLanguages() {
            gsap.to(this.$refs.languages, {
                opacity: 0,
                y: 30,
                pointerEvents: 'none',
                duration: 0.2,
                ease: 'power2.in'
            })
            gsap.to(this.$refs.languagesBtn.querySelector('.cf-ring'), {
                opacity: 0,
                width: '50%',
                height: '50%',
                duration: 0.2,
                ease: 'power2.in'
            }, '-=0.2')
        },
        changeLanguage(language) {
            this.currentLanguage = language;
        },
        setMetaTag(attr, key, content) {
            if (typeof document === 'undefined') return;
            let el = document.head.querySelector(`meta[${attr}="${key}"]`);
            if (!el) {
                el = document.createElement('meta');
                el.setAttribute(attr, key);
                document.head.appendChild(el);
            }
            el.setAttribute('content', content);
        },
        updateMetaTags() {
            // Fallback chain for every meta value: current page field → global
            // Settings field → hard-coded default. (globalMeta already carries
            // the per-site value with the default-site fallback resolved in the
            // settings API.)
            const pm = this.pageMeta || {};
            const gm = this.globalMeta || {};
            const pick = (key) => (pm[key] || gm[key] || '');

            // Title fallback chain:
            //   page metaTitle → (generic page) "Page Title | Global Meta Title"
            //   → global metaTitle → hard-coded default.
            let title = pm.metaTitle || '';
            if (!title) {
                if (pm._pageTitle) {
                    title = pm._pageTitle + (gm.metaTitle ? ' | ' + gm.metaTitle : '');
                } else {
                    title = gm.metaTitle || '';
                }
            }
            title = title || 'CROSSFIRE | OFFICIAL WEBSITE';

            const description = pick('metaDescription')
                || 'Official website for Crossfire, a AAA single-player tactical action-adventure game';
            const image = pick('shareImage');
            const video = pick('shareVideo');

            document.title = title;
            this.setMetaTag('name', 'description', description);

            // Open Graph (Facebook, LinkedIn, iMessage, Discord, …)
            this.setMetaTag('property', 'og:title', title);
            this.setMetaTag('property', 'og:description', description);
            this.setMetaTag('property', 'og:type', video ? 'video.other' : 'website');
            if (typeof window !== 'undefined') {
                this.setMetaTag('property', 'og:url', window.location.href);
            }

            // Twitter / X
            this.setMetaTag('name', 'twitter:title', title);
            this.setMetaTag('name', 'twitter:description', description);

            if (image) {
                // og:image is also the required poster image for video shares.
                this.setMetaTag('property', 'og:image', image);
                this.setMetaTag('property', 'og:image:secure_url', image);
                this.setMetaTag('property', 'og:image:alt', title);
                this.setMetaTag('name', 'twitter:image', image);
            }
            // Twitter card type: large image when we have an image, else summary.
            this.setMetaTag('name', 'twitter:card', image ? 'summary_large_image' : 'summary');

            if (video) {
                const ext = (video.split('?')[0].split('.').pop() || '').toLowerCase();
                const videoType = ext === 'webm' ? 'video/webm'
                    : ext === 'ogv' || ext === 'ogg' ? 'video/ogg'
                    : ext === 'mov' ? 'video/quicktime'
                    : 'video/mp4';
                this.setMetaTag('property', 'og:video', video);
                this.setMetaTag('property', 'og:video:url', video);
                this.setMetaTag('property', 'og:video:secure_url', video);
                this.setMetaTag('property', 'og:video:type', videoType);
            }
        },
        // Pull the meta values out of a page/global data object. `pageTitle`
        // (the entry's own title) is only passed for generic pages, where the
        // title falls back to "Page Title | Global Meta Title".
        extractMeta(data, pageTitle) {
            const d = data || {};
            return {
                metaTitle: d.metaTitle || '',
                metaDescription: d.metaDescription || '',
                shareImage: d.shareImage || '',
                shareVideo: d.shareVideo || '',
                _pageTitle: pageTitle || '',
            };
        },
        isKoreanSite(slug, handle) {
            // Normalise the site slug / handle and match Korean variants
            // (korean, ko, ko-kr, ko_kr, kokr, …).
            const normalise = (v) => (v ? String(v).toLowerCase().replace(/[^a-z0-9]/g, '') : '');
            const koreanKeys = ['korean', 'ko', 'kokr'];
            const slugNorm = normalise(slug);
            const handleNorm = normalise(handle);
            if (koreanKeys.includes(slugNorm) || koreanKeys.includes(handleNorm)) return true;
            // Match slugs/handles that start with the `ko` language prefix (e.g. ko-kr, kokr).
            return slugNorm.startsWith('ko') || handleNorm.startsWith('ko');
        },
        isRussianSite(slug, handle) {
            // Normalise the site slug / handle and match Russian variants
            // (russian, ru, ru-ru, ru_ru, ruru, …).
            const normalise = (v) => (v ? String(v).toLowerCase().replace(/[^a-z0-9]/g, '') : '');
            const russianKeys = ['russian', 'ru', 'ruru'];
            const slugNorm = normalise(slug);
            const handleNorm = normalise(handle);
            if (russianKeys.includes(slugNorm) || russianKeys.includes(handleNorm)) return true;
            // Match slugs/handles that start with the `ru` language prefix (e.g. ru-ru, ruru).
            return slugNorm.startsWith('ru') || handleNorm.startsWith('ru');
        },
        debounce(func){
            var timer;
            return function(event){
                if(timer) clearTimeout(timer);
                timer = setTimeout(func,200,event);
            };
        },
        showMobileBlocker(skipHide = false) {
            if (this.popupState?.id === 'watch') {
                if (this.$refs.mobileBlocker) {
                    this.$refs.mobileBlocker.style.display = "none";
                }
                this.blockerActive = false;
                return false;
            }
            if(window.innerWidth > window.innerHeight && (window.innerWidth < 768 || window.innerHeight < 600)) {
                // mobile side view, show blocker
                if (this.$refs.mobileBlocker) {
                    this.$refs.mobileBlocker.style.display = "flex";
                }
                this.blockerShown = true;
                this.blockerActive = true;
                return true;
            } else {
                if (skipHide && this.blockerShown) {
                    return false;
                }
                if (this.$refs.mobileBlocker) {
                    this.$refs.mobileBlocker.style.display = "none";
                }
                this.blockerActive = false;
                return false;
            }
        },
        resizeHandler() {
            this.handleResize();

            // On mobile devices, orientation changes can take a few hundred milliseconds to report correct dimensions.
            // Run the check after a short delay to capture the final settled layout dimensions.
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
            this.resizeTimeout = setTimeout(() => {
                this.handleResize();
            }, 200);
        },
        handleResize() {
            const currentWidth = window.innerWidth;
            const blockerActive = this.showMobileBlocker(true);
            const isTrailerOpen = this.popupState?.id === 'watch';

            // Rotating while the trailer is open leaves the pinned GSAP timeline in a
            // broken state, so the page must rebuild (reload) once the trailer closes.
            // We only flag it here; the reload is deferred to handleGlobalPopupClose and
            // gated on being back in portrait, so it never lands on the rotate blocker.
            if (isTrailerOpen && currentWidth !== this.prevWidth) {
                this.resizedWhileTrailerOpen = true;
            }

            if (!blockerActive && (!isTrailerOpen || this.blockerShown)) {
                if (this.blockerShown || currentWidth !== this.prevWidth) {
                    const wasBlockerShown = this.blockerShown;
                    this.blockerShown = false;
                    this.$refs.mainContainer.classList.add('h-screen');
                    this.$refs.mainContainer.classList.add('overflow-hidden');
                    if (this.scrollTrigger) this.scrollTrigger.disable();
                    if (this.finalScrollTrigger) this.finalScrollTrigger.disable();
                    gsap.set(this.$refs.resizeOverlay, { opacity: 1 });
                    gsap.set(this.$refs.mainContainer, { opacity: 0 });

                    if (wasBlockerShown) {
                        // Immediately show a solid black screen (hide logo)
                        gsap.set(this.$refs.resizeOverlayLogo, { opacity: 0 });
                        // Now we can safely hide the mobile blocker because the black resizeOverlay is opaque!
                        if (this.$refs.mobileBlocker) {
                            this.$refs.mobileBlocker.style.display = "none";
                        }
                        this.blockerActive = false;
                    } else {
                        // Normal window resize, animate logo in
                        gsap.to(this.$refs.resizeOverlayLogo, { opacity: 1, duration: 0.5, ease: 'power2.out' });
                    }

                    this.debouncedReload();

                    // Update the stored width
                    this.prevWidth = currentWidth;
                }
            } else {
                this.prevWidth = currentWidth;
            }
        },
        handleChangeLanguage(site) {
            if (site.isExternal) {
                window.open(site.url || 'https://www.tencent.com', '_blank');
                if (this.$refs.mobileMenu) {
                    this.$refs.mobileMenu.closeMenu();
                }
                return;
            }
            let path = window.location.pathname;
            if (this.sitePrefix) {
                path = path.replace(new RegExp('^/' + this.sitePrefix + '(/|$)', 'i'), '/');
            }
            path = path.replace(/^\/+/g, '');
            window.location.href = window.location.origin + '/' + (site.slug ? site.slug + '/' : '') + path;
        },
        isHomePage() {
            return this.isHomePageRoute(this.$route?.path);
        },
        isHomePageRoute(path) {
            let slug = this.getSlugFromLocation(path);
            if (!slug) return true;
            
            let prefix = this.sitePrefix;
            if (!prefix && site && site.sites) {
                const firstSegment = slug.split('/')[0];
                const matched = site.sites.find(s => s.slug && s.slug.toLowerCase() === firstSegment.toLowerCase());
                if (matched) {
                    prefix = matched.slug.toLowerCase();
                }
            }

            if (prefix) {
                slug = slug.replace(new RegExp('^' + prefix + '(/|$)', 'i'), '');
            }
            if (!slug) return true;
            
            const homeSlugs = [
                'intro', 'circles', 'unlikely-allies', 'developed-by', 'trailer',
                'cinematic', 'cinematic-narrative', 'tactical', 'combat', 'allies',
                'environments', 'faq', 'media', 'videos', 'screenshots', 'downloads'
            ];
            
            return homeSlugs.includes(slug.split('/')[0]);
        },
        async fetchGlobalData() {
            let isHome = this.isHomePageRoute(window.location.pathname);
            let processedSites = [];
            
            try {
                // 1. Detect language prefix from sites list
                const sitesUrl = window.config.localMode 
                    ? `/api/sites.json` 
                    : `${window.config.apiroot}sites${window.config.apiext}`;
                
                const resSites = await axios.get(sitesUrl);
                const pathSegment = window.location.pathname.split('/')[1];
                const matchedSite = resSites.data.sites && resSites.data.sites.find((s) => s.slug && s.slug.toLowerCase() === pathSegment.toLowerCase());
                let siteHandle = 'default';
                if (matchedSite) {
                    this.sitePrefix = matchedSite.slug.toLowerCase();
                    this.currentLanguage = matchedSite.slug;
                    siteHandle = matchedSite.handle || 'default';
                } else {
                    this.sitePrefix = null;
                    const defaultSite = resSites.data.sites && resSites.data.sites.find((s) => s.slug === '' || s.handle === 'default');
                    if (defaultSite) {
                        siteHandle = defaultSite.handle || 'default';
                    }
                }
                this.siteHandle = siteHandle;
                this.useAlternativeFont = this.isRussianSite(this.currentLanguage, siteHandle);
                isHome = this.isHomePageRoute(window.location.pathname);
                
                // 2. Prepare request URLs — API endpoints always live at /api/... (no locale prefix)
                // The sitePrefix is a Vue router concern only; do NOT prepend it to API calls.
                const headerUrl = window.config.localMode 
                    ? `/api/header.json` 
                    : `${window.config.apiroot}header${window.config.apiext}`;
                    
                const footerUrl = window.config.localMode 
                    ? `/api/footer.json` 
                    : `${window.config.apiroot}footer${window.config.apiext}`;

                const settingsUrl = window.config.localMode 
                    ? `/api/settings.json` 
                    : `${window.config.apiroot}settings${window.config.apiext}`;
                
                // Determine active slug
                let slug = this.getSlugFromLocation(window.location.pathname);
                if (this.sitePrefix && slug) {
                    slug = slug.replace(new RegExp('^' + this.sitePrefix + '(/|$)', 'i'), '');
                }
                if (!slug) slug = '';
                
                // isHome is already declared at the top of the function
                
                let pageUrl;
                if (isHome) {
                    pageUrl = window.config.localMode 
                        ? `/api/home.json` 
                        : `${window.config.apiroot}home${window.config.apiext}`;
                } else {
                    pageUrl = window.config.localMode 
                        ? `/api/${slug}.json` 
                        : `${window.config.apiroot}generic${window.config.apiext}`;
                }
                
                const params = {};
                params.site = siteHandle;
                if (!isHome && !window.config.localMode) {
                    params.slug = slug;
                }
                
                // 3. Fetch header, footer, and page data in parallel
                const [resHeader, resFooter, resPage, resSettings] = await Promise.all([
                    axios.get(headerUrl, { params: { site: siteHandle } }),
                    axios.get(footerUrl, { params: { site: siteHandle } }),
                    axios.get(pageUrl, { params }),
                    axios.get(settingsUrl, { params: { site: siteHandle } }).catch(err => {
                        console.error("Failed to fetch settings, using defaults:", err);
                        return { data: { disableAgeGate: false, disableFaq: false, disableVideos: false, disableDownloads: false, disableConceptArt: false } };
                    })
                ]);
                
                if (this.useAlternativeFont) {
                    if (resSettings && resSettings.data) resSettings.data = convertSpacesInObject(resSettings.data);
                    if (resHeader.data) resHeader.data = convertSpacesInObject(resHeader.data);
                    if (resFooter.data) resFooter.data = convertSpacesInObject(resFooter.data);
                    if (resPage.data) resPage.data = convertSpacesInObject(resPage.data);
                }

                // 4. Update the reactive state
                if (typeof window !== 'undefined') {
                    window.overrides = {};
                }

                if (resSettings && resSettings.data) {
                    this.disableAgeGate = resSettings.data.disableAgeGate === true;
                    if (typeof window !== 'undefined' && resSettings.data.overrides) {
                        window.overrides = !Array.isArray(resSettings.data.overrides) ? resSettings.data.overrides : {};
                    }
                    this.disableFaq = resSettings.data.disableFaq === true;
                    this.disableVideos = resSettings.data.disableVideos === true;
                    this.disableDownloads = resSettings.data.disableDownloads === true;
                    this.disableConceptArt = resSettings.data.disableConceptArt === true;

                    // Editable interface text (managed in the Settings global set,
                    // translatable per site). Merge into `site` so child sections
                    // that already receive :site can read them. Empty values fall
                    // back to the defaults at the point of use.
                    this.site.loadingText = resSettings.data.loadingText || '';
                    this.site.scrollToEnterText = resSettings.data.scrollToEnterText || '';
                    this.site.scrollIndicatorText = resSettings.data.scrollIndicatorText || '';
                    this.site.downloadButtonText = resSettings.data.downloadButtonText || '';

                    // SEO/share meta from the Settings global (per-site fallback).
                    // Stored as globalMeta — the page's own fields override it.
                    this.globalMeta = this.extractMeta(resSettings.data);
                    this.updateMetaTags();

                    // Store links moved from the home entry to the Settings
                    // global set; merge into `site` so the trailer/menu read them.
                    this.site.ps5Link = resSettings.data.ps5Link || '';
                    this.site.xboxLink = resSettings.data.xboxLink || '';
                    this.site.steamLink = resSettings.data.steamLink || '';
                    this.site.epicGamesLink = resSettings.data.epicGamesLink || '';
                }
                this.isSettingsLoaded = true;

                // The Russian site swaps headings to the alternative font (the
                // default heading font has no Cyrillic glyphs). Detect it from
                // the site slug/handle rather than a backend setting.
                this.useAlternativeFont = this.isRussianSite(this.currentLanguage, siteHandle);

                // Korean site uses the esamanru webfont for ALL text, since the
                // default Latin fonts have no Hangul glyphs. Detect the Korean
                // site from its slug/handle and toggle the body font accordingly.
                this.useKoreanFont = this.isKoreanSite(this.currentLanguage, siteHandle);

                // A non-default (translated) site is active when there's a site
                // prefix. The SplitText anti-clip + overlap-shrink system is
                // applied only to these localized versions, never the English base.
                this.isLocalized = !!this.sitePrefix;

                // Per-language body hook (e.g. `lang-ch-tw`, `lang-ko`, `lang-ru`)
                // so CSS can make language-specific tweaks. Derived from the site
                // slug; empty on the default English site.
                this.languageClass = this.sitePrefix
                    ? 'lang-' + String(this.sitePrefix).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
                    : '';

                if (this.disableAgeGate) {
                    this.ageGateVerified = true;
                }
                if (resHeader.data) {
                    this.site.nav = resHeader.data;
                    if (this.site.nav && this.site.nav.nav) {
                        this.site.nav.nav = this.site.nav.nav.filter(item => {
                            const link = (item.link || '').toLowerCase().trim();
                            if (this.disableFaq && (link === 'faq' || link === '/faq')) {
                                return false;
                            }
                            if (this.disableDownloads && (link === 'downloads' || link === '/media/downloads')) {
                                return false;
                            }
                            return true;
                        });

                        if (this.disableVideos) {
                            this.site.nav.nav = this.site.nav.nav.map(item => {
                                const link = (item.link || '').toLowerCase().trim();
                                if (link === '/media/videos' || link === 'media/videos') {
                                    return { ...item, link: '/media/screenshots' };
                                }
                                return item;
                            });
                        }
                    }
                }
                if (resFooter.data) {
                    this.site.footer = resFooter.data;
                }
                if (resSites.data && resSites.data.sites) {
                    const LANGUAGE_MAP = {
                        // English variations
                        'english': 'English',
                        'en': 'English',
                        '': 'English',

                        // German variations
                        'german': 'Deutsch',
                        'deutsch': 'Deutsch',
                        'de': 'Deutsch',
                        'de-de': 'Deutsch',
                        'de_de': 'Deutsch',
                        'dede': 'Deutsch',

                        // Italian variations
                        'italian': 'Italiano',
                        'italiano': 'Italiano',
                        'it': 'Italiano',
                        'it-it': 'Italiano',
                        'it_it': 'Italiano',
                        'itit': 'Italiano',

                        // Spanish (Spain) variations
                        'spanish': 'Español (España)',
                        'es': 'Español (España)',
                        'es-es': 'Español (España)',
                        'es_es': 'Español (España)',
                        'eses': 'Español (España)',

                        // Spanish (LATAM) variations
                        'spanishmexican': 'Español (LATAM)',
                        'esmx': 'Español (LATAM)',
                        'es-mx': 'Español (LATAM)',
                        'es_mx': 'Español (LATAM)',

                        // French variations
                        'french': 'Français',
                        'fr': 'Français',
                        'fr-fr': 'Français',
                        'fr_fr': 'Français',
                        'frfr': 'Français',

                        // Portuguese (Brazil) variations
                        'brazilian': 'Português (Brasil)',
                        'ptbr': 'Português (Brasil)',
                        'pt-br': 'Português (Brasil)',
                        'pt_br': 'Português (Brasil)',

                        // Russian variations
                        'russian': 'Русский',
                        'ru': 'Русский',
                        'ru-ru': 'Русский',
                        'ru_ru': 'Русский',
                        'ruru': 'Русский',

                        // Japanese variations
                        'japanese': '日本語',
                        'ja': '日本語',
                        'jp': '日本語',
                        'ja-jp': '日本語',
                        'ja_jp': '日本語',
                        'jajp': '日本語',

                        // Korean variations
                        'korean': '한국어',
                        'ko': '한국어',
                        'ko-kr': '한국어',
                        'ko_kr': '한국어',
                        'kokr': '한국어',

                        // Taiwanese variations
                        'taiwanese': '繁體中文',
                        'ch-tw': '繁體中文',
                        'chtw': '繁體中文',
                        'zh-tw': '繁體中文',
                        'zh_tw': '繁體中文',
                        'zhtw': '繁體中文'
                    };

                    const rawSites = resSites.data.sites;
                    processedSites = [];
                    let insertedChinese = false;

                    const chineseSimplified = {
                        name: "简体中文",
                        slug: "zh-cn",
                        isExternal: true,
                        url: "https://crossfire.qq.com/"
                    };

                    for (const s of rawSites) {
                        const cleanName = s.name ? s.name.toLowerCase().replace(/[^a-z0-9]/g, '') : '';
                        const cleanSlug = s.slug ? s.slug.toLowerCase().trim() : '';

                        let mappedName = s.name;

                        // 1. Check direct name match
                        if (LANGUAGE_MAP[cleanName]) {
                            mappedName = LANGUAGE_MAP[cleanName];
                        } 
                        // 2. Check direct slug match
                        else if (LANGUAGE_MAP[cleanSlug]) {
                            mappedName = LANGUAGE_MAP[cleanSlug];
                        }
                        // 3. Fallback to matching language prefixes in the slug (e.g. 'de-de' -> 'de', 'es-es' -> 'es')
                        else {
                            const slugPrefix = cleanSlug.split(/[-_]/)[0];
                            if (LANGUAGE_MAP[slugPrefix]) {
                                mappedName = LANGUAGE_MAP[slugPrefix];
                            }
                        }

                        // Create a brand new object to avoid strict mode/readonly mutation errors in Vue/Axios
                        const siteObj = {
                            ...s,
                            name: mappedName
                        };
                        
                        // Insert Chinese (Simplified) right before Taiwanese to match the requested order
                        if ((cleanName === 'taiwanese' || cleanSlug === 'zh-tw' || cleanSlug === 'zh_tw' || cleanSlug === 'zhtw') && !insertedChinese) {
                            processedSites.push(chineseSimplified);
                            insertedChinese = true;
                        }
                        processedSites.push(siteObj);
                    }

                    if (!insertedChinese) {
                        processedSites.push(chineseSimplified);
                    }

                    this.site.sites = processedSites;
                }
                
                if (isHome) {
                    // Merge home page content back into site config
                    const pageData = { ...resPage.data };
                    delete pageData.sites; // Prevent overwriting our mapped sites array
                    delete pageData.nav;   // Prevent overwriting the header
                    delete pageData.footer;// Prevent overwriting the footer
                    this.site = { ...this.site, ...pageData };
                    this.currentPageData = null;
                } else {
                    // Set generic page content
                    this.currentPageData = resPage.data;
                }

                // Page-level meta overrides the global; re-apply the head tags.
                // For generic pages, pass the entry title so the title can fall
                // back to "Page Title | Global Meta Title".
                this.pageMeta = this.extractMeta(resPage.data, isHome ? '' : resPage.data.title);
                this.updateMetaTags();

                // Double check processedSites are correctly applied
                if (resSites.data && resSites.data.sites) {
                    this.site.sites = processedSites;
                }
                
                this.isGlobalDataLoaded = true;
                this.inited = true;
                this.isLoadingPage = false;
                this.isLoading = false;
                
                // 5. Post-fetch animation trigger
                this.$nextTick(() => {
                    this.scrollbarTrack();
                    if (isHome) {
                        this.initAnimation();
                        this.warmupAssets();
                        this.staggeredMount();
                        this.triggerTimelineBuild();
                        this.checkStartIntro();
                    } else {
                        // For generic pages, ensure full mount state and correct body classes
                        this.mountStage = 9;
                        this.unlocked = true;
                        document.body.style.overflow = 'auto';
                        document.documentElement.style.overflow = 'auto';
                        if (this.$refs.mainContainer) {
                            this.$refs.mainContainer.classList.remove('h-screen', 'overflow-hidden');
                        }
                        this.$nextTick(() => {
                            if (this.$refs.footerComponent) {
                                this.$refs.footerComponent.initAnimation();
                            }
                            ScrollTrigger.refresh();
                        });
                    }
                });
                
            } catch (err) {
                console.error("Failed to fetch global and page data:", err);
                if (!this.isSettingsLoaded) {
                    this.disableAgeGate = false;
                    this.disableFaq = false;
                    this.disableVideos = false;
                    this.disableDownloads = false;
                    this.disableConceptArt = false;
                    this.useAlternativeFont = false;
                    this.useKoreanFont = false;
                    this.isSettingsLoaded = true;
                }
                if (this.disableAgeGate) {
                    this.ageGateVerified = true;
                }
                this.isGlobalDataLoaded = true;
                this.inited = true;
                this.isLoadingPage = false;
                this.isLoading = false;
                // Fallback to local animations
                this.mountStage = 9;
                this.initAnimation();
                this.$nextTick(() => {
                    if (isHome) {
                        this.warmupAssets();
                        this.triggerTimelineBuild();
                        this.checkStartIntro();
                    }
                });
            }
        },
        async handleRouteChange(to, from) {
            if (!this.inited) return;
            const toHome = this.isHomePage();
            const fromHome = from ? this.isHomePageRoute(from.path) : false;
            
            // Clean up mobile menu on a *genuine* navigation (link / back-forward).
            // Skip scroll-driven slug→route syncs: those fire while scrolling and
            // their handler runs async — by then the user may have just tapped to
            // open the menu, and closing it here would clobber that open (the
            // "can't open while scrolling / two taps" bug). The flag is set right
            // before each scroll-sync replace and consumed here.
            const wasScrollSync = this._scrollSyncNav;
            this._scrollSyncNav = false;
            if (this.$refs.mobileMenu && this.$refs.mobileMenu.isOpen && to.path !== from?.path && !wasScrollSync) {
                this.$refs.mobileMenu.closeMenu();
            }
            
            // Get new slug
            let slug = this.getSlugFromLocation(to.path);
            if (this.sitePrefix && slug) {
                slug = slug.replace(new RegExp('^' + this.sitePrefix + '(/|$)', 'i'), '');
            }
            if (!slug) slug = '';
            
            if (toHome) {
                // transitioning to (or moving within) the Home Page
                this.currentPageData = null;
                
                // If transitioning from a generic page to Home, restore GSAP and scroll locks
                if (from && !fromHome) {
                    // Reset scroll to top instantly
                    window.scrollTo(0, 0);

                    this.isLoading = true; // Show loading layer briefly
                    // Refetch home page data to ensure correct state (no locale prefix on API URL)
                    const pageUrl = window.config.localMode 
                        ? `/api/home.json` 
                        : `${window.config.apiroot}home${window.config.apiext}`;
                    
                    try {
                        const res = await axios.get(pageUrl, { params: { site: this.siteHandle } });
                        const pageData = { ...res.data };
                        delete pageData.sites; // Prevent overwriting our mapped sites array
                        delete pageData.nav;   // Prevent overwriting the header
                        delete pageData.footer;// Prevent overwriting the footer
                        this.site = { ...this.site, ...pageData };
                        this.pageMeta = this.extractMeta(res.data);
                        this.updateMetaTags();
                    } catch (err) {
                        console.error("Error reloading home page:", err);
                    }
                    
                    // Reset timeline and intro states synchronously before setting isLoading to false
                    this.isReadyToStart = false;
                    this.timelineBuildInitiated = false;
                    this.tl = null;
                    this.finalTL = null;
                    this.scrollTrigger = null;
                    this.finalScrollTrigger = null;
                    this._cachedLabelEntries = null;
                    this.mountStage = 0;
                    this.unlocked = false;
                    this.hasStartedIntro = false;

                    this.isLoading = false;
                    
                    this.$nextTick(() => {
                        this.scrollbarTrack();
                        
                        // Re-initialize timeline instances and register the onUpdate callback
                        this.initAnimation();
                        
                        this.warmupAssets();
                        this.staggeredMount();
                        this.triggerTimelineBuild();
                    });
                } else {
                    // Just scroll to the section inside the existing home layout
                    // ONLY if the route change was NOT triggered by scroll-based URL sync or active auto-scrolling
                    const normalizeSlug = (s) => {
                        if (!s || s === '/' || s === 'intro') return 'intro';
                        return s;
                    };
                    const targetSlug = slug || 'intro';
                    if (normalizeSlug(targetSlug) !== normalizeSlug(this.lastSlug.value) && !this.isAutoScrolling) {
                        this.handleInternalLink(to.path);
                    }
                }
            } else {
                // transitioning to a Generic Page
                this.isLoadingPage = true;
                
                // Reset scroll to top instantly
                window.scrollTo(0, 0);
                
                // Kill/clean up GSAP ScrollTriggers and timelines to prevent memory/VRAM leaks and detached DOM element references
                if (this.scrollTrigger) {
                    this.scrollTrigger.kill(true);
                    this.scrollTrigger = null;
                }
                if (this.finalScrollTrigger) {
                    this.finalScrollTrigger.kill(true);
                    this.finalScrollTrigger = null;
                }
                if (this.tl) {
                    this.tl.kill();
                    this.tl = null;
                }
                if (this.finalTL) {
                    this.finalTL.kill();
                    this.finalTL = null;
                }
                this.timelineBuildInitiated = false;
                this.isReadyToStart = false;
                this._cachedLabelEntries = null;
                
                // Revert any body/html styles that lock scrolling
                document.body.style.overflow = 'auto';
                document.documentElement.style.overflow = 'auto';
                
                // Clear any GSAP header and footer inline styles so they revert to standard class styles cleanly
                if (this.$refs.header) {
                    gsap.killTweensOf(this.$refs.header);
                    if (this.$refs.header.querySelectorAll('.light').length) gsap.killTweensOf(this.$refs.header.querySelectorAll('.light'));
                    if (this.$refs.header.querySelectorAll('.dark').length) gsap.killTweensOf(this.$refs.header.querySelectorAll('.dark'));
                    gsap.set([this.$refs.header, this.$refs.header.querySelectorAll('.light'), this.$refs.header.querySelectorAll('.dark')], { clearProps: "all" });
                }
                
                if (this.$refs.footerComponent && this.$refs.footerComponent.$el) {
                    gsap.killTweensOf(this.$refs.footerComponent.$el);
                    gsap.set(this.$refs.footerComponent.$el, { clearProps: "all" });
                }
                
                // Fetch generic page content (no locale prefix on API URL)
                const pageUrl = window.config.localMode 
                    ? `/api/${slug}.json` 
                    : `${window.config.apiroot}generic${window.config.apiext}`;
                
                const params = {};
                params.site = this.siteHandle;
                if (!window.config.localMode) {
                    params.slug = slug;
                }
                
                try {
                    const res = await axios.get(pageUrl, { params });
                    this.currentPageData = res.data;
                    this.pageMeta = this.extractMeta(res.data, res.data.title);
                    this.updateMetaTags();
                } catch (err) {
                    console.error("Error fetching generic page:", err);
                    this.currentPageData = null; // will show 404
                } finally {
                    this.isLoadingPage = false;
                    this.$nextTick(() => {
                        if (this.$refs.footerComponent) {
                            this.$refs.footerComponent.initAnimation();
                        }
                        ScrollTrigger.refresh();
                    });
                }
            }
        },
        handlePopupChangeItem(newIndex) {
            const slider = this.popupState.slider;
            const items = this.activePopupItems;
            if (!items || !items[newIndex]) return;

            const item = items[newIndex];
            const id = `media${newIndex}`;
            const type = item.type;
            const video = item.type === 'embed' || item.type === 'video' ? item.video : null;
            const image = item.thumbnail;

            this.popupState.type = type;
            this.popupState.video = video;
            this.popupState.image = image;
            this.popupState.id = id;
            this.popupState.index = newIndex;

            this.$router.replace({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    popup: id,
                    index: newIndex,
                    slider: slider
                }
            });

            const mediaComponent = this.$refs.environments?.$refs?.media;
            if (mediaComponent) {
                const sliderComponent = mediaComponent.$refs[`${slider}Slider`];
                if (sliderComponent) {
                    sliderComponent.slideTo(newIndex);
                }
            }
        }
    },
    computed: {
        activePopupItems() {
            const slider = this.popupState.slider;
            if (!slider || !this.site || !this.site.media) return [];
            return this.site.media[slider] || [];
        },
        // CJK scroll-indicator text must stack vertically with upright glyphs
        // (writing-mode), not be rotated 90° like the Latin label.
        scrollIndicatorIsCjk() {
            return hasCJK(this.site && this.site.scrollIndicatorText);
        },
        showGlobalLoader() {
            if (this.blockerActive) return false;
            if (this.isLoading) return true;
            if (this.isLoadingPage) return true;
            if (this.isHomePage()) {
                if (this.ageGateVerified && !this.hasStartedIntro) {
                    return true;
                }
            }
            return false;
        }
    },
    watch: {
        $route(to, from) {
            this.handleRouteChange(to, from);
            this.$nextTick(() => {
                this.showMobileBlocker();
            });
        },
        isLoading(newVal) {
            if (!newVal) {
                this.$nextTick(() => {
                    this.checkStartIntro();
                });
            }
        },
        useAlternativeFont: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    document.body.classList.add('use-alternative-font');
                    this.site = convertSpacesInObject(this.site);
                } else {
                    document.body.classList.remove('use-alternative-font');
                }
            }
        },
        useKoreanFont: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    document.body.classList.add('use-korean-font');
                } else {
                    document.body.classList.remove('use-korean-font');
                }
            }
        },
        isLocalized: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    document.body.classList.add('is-localized');
                } else {
                    document.body.classList.remove('is-localized');
                }
            }
        },
        languageClass: {
            immediate: true,
            handler(newVal) {
                // Drop any previously applied lang-* class, then add the current one.
                Array.from(document.body.classList)
                    .filter((c) => c.indexOf('lang-') === 0)
                    .forEach((c) => document.body.classList.remove(c));
                if (newVal) document.body.classList.add(newVal);
            }
        }
    },
    provide() {
        return {
            openPopup: this.openPopup // make it available to children
        };
    }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s cubic-bezier(0.25, 1, 0.5, 1);
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
